<div
    class="landing-page__container"
    *ngIf="true"
    fxLayout="column"
    fxLayoutAlign="center center"
>
    <h1 class="landing-page__title">
        {{ "Welcome to the Pathways community" | translate }}!
    </h1>
    <div class="landing-page__subtitle">
        <p style="text-align: center; margin-top: -16px; margin-bottom: 16px">
            {{ "You've been invited to create an account on the student portal" | translate }}.
            <br />
            {{
                "Confirm your date of birth below" | translate
            }}.
        </p>
    </div>

    <mat-form-field appearance="outline" class="landing-page__field">
        <mat-label>
            {{ "Date of Birth" | translate }}
        </mat-label>
        <input
            matInput
            [matDatepicker]="picker"
            [formControl]="dateToValidate"
        />
        <mat-hint>{{ "MM/DD/YYYY" | translate }}</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>{{ "The date entered does not match our records" | translate }}.</mat-error>
    </mat-form-field>

    <button
        class="landing-page__button"
        mat-flat-button
        color="primary"
        [disabled]="false"
        (click)="validateDateOfBirth()"
        data-test="create-account"
    >
        <!-- <re-captcha
        #captchaRef="reCaptcha"
        (resolved)="onCaptchaResolve()"
        (error)="onCaptchaError($event)"
        siteKey="{{siteKey}}"
        size="invisible"
        ></re-captcha> -->

        {{ "Proceed" | translate }}
    </button>
</div>
